import { Fragment, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { QuerySuggestionSkeleton } from "../../Skeleton/autoSuggestPopup/querySuggestionSkeleton";
import { isValidArray } from "../../Layout/Common/common";
import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const QuerySuggestion = ({ suggestions, isOpen }) => {
  const [queryList, setQueryList] = useState(null);

  useEffect(() => {
    if (suggestions) setQueryList(suggestions);
  }, [suggestions]);

  return (
    <Fragment>
      <div className="search-tags-title ">
        <h5>Suggestions</h5>
      </div>
      <div className="search-tags-details">
        {isOpen ? (
          <ul style={{ height: "auto" }}>
            {isValidArray(queryList) &&
              queryList.slice(0, 5).map((item, idx) => (
                <li key={item.value}>
                  <Link
                    to={PAGES.SEARCH + "?q=" + encodeURIComponent(item.query)}
                  >
                    <span className="wes-search" />
                    <span dangerouslySetInnerHTML={{ __html: item.value }} />
                  </Link>
                </li>
              ))}
          </ul>
        ) : (
          <QuerySuggestionSkeleton />
        )}
      </div>
    </Fragment>
  );
};
